module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-250-Classes-Active-0828b3b17a1f8c5c04cadef7cc267fcf.png";